import BotHeadSpin from './BotHeadSpin'

export default BotHeadSpin
